import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { isEmpty } from 'lodash'
import Error from './Error'
import Spinner from './Spinner'

class VCGitemPostCategories extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cats: null,
      error: null
    }

    // never tested
    if (isEmpty(props.cats.items) || (props.cats.code !== null && props.cats.code !== 200))
      props.findAllCats()
  }

  static getDerivedStateFromProps(props, state) {

    if (props.cats.code !== null && props.cats.code !== 200)
      return { error: 'err.oops' }

    if (props.cats.isFetching)
      return null

    return {
      cats: props.ids.map((cat, key) => {
        // FIXME!!! refactoring: findCatByName
        const obj = props.cats.items
        let current
        Object.keys(obj).forEach(function(objKey) {
          if (obj[objKey].getTarget() === cat) {
            current = obj[objKey]
          }
        })
        return current
      }).filter(cat => cat !== undefined),
      error: null
    }
  }

  render() {
    if (this.state.error)
      return <Error>{this.props.t(this.state.error.keys || this.state.error, this.state.error.options)}</Error>

    if (this.props.cats.isFetching)
      return <Spinner>{this.props.t('msg.loadingCat', { count: 100 })}</Spinner>

    return (
      <ul className={this.props.className}>{this.state.cats.map((cat, key) => {
        return (<li data-cat-id={cat.getTarget()} key={key}>{cat.getTitle()}</li>)
      })}</ul>
    )
  }
}

export default translate()(VCGitemPostCategories)



// WEBPACK FOOTER //
// ./src/components/VCGitemPostCategories.js